import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-p404',
    styleUrls: ['./error.component.scss'],
    templateUrl: './p404.component.html',
    imports: [TranslatePipe],
})
export class P404Component {
  protected location = inject(Location);
}
